<template>
    <ul class="list__ul">
        <!--CAMPING CAR NEW-->
        <template v-if="isNewCampingCar(guaranty.details)">
            <li>
                <b>Moteur :</b>
                <div>
                  Toutes les pièces lubrifiées du bloc cylindre et de la culasse,
                  culbuteurs cache-culbuteurs, tiges et guides de culbuteurs,
                  chemises, soupapes, les joints moteur et de la culasse,
                  poussoirs, arbres à cames, pignons de distribution,
                  couronne de volant, pompe à huile, pistons et axes de pistons,
                  segments, bloc cylindres, coussinets, vilebrequin et paliers,
                  entrainement du distributeur, les collecteurs d’admission et d’échappement,
                  couronne du démarreur, volant-moteur.
                </div>
            </li>
            <li>
                <b>Boite de vitesses :</b>

                <div>
                  Manuelle : Toutes défaillance internes, pignons, arbres sélecteurs synchros,
                  axe des satellites, bagues, baladeurs, boîtiers de différentiel, couple de transmission.
                </div>

                <div>
                  Automatique : Les pignons, la pompe à huile, les bagues et arbres,
                  le convertisseur de couple (sauf joints), les vannes et soupapes,
                  le régulateur, le plateau, bandes et disques, boite à clapets,
                  clapets de sécurité, couple conique, différentiels, planétaires,
                  roulement de pont, boite de transfert et réducteur.
                </div>
            </li>
            <li>
                <b>Dispositif de transmission :</b>
                <div>
                  Toutes les pièces internes y compris l’arbre de transmission,
                  les cardans, couples coniques, différentiels, planétaires,
                  roulements de pont, boite de transfert et réducteur.
                </div>
            </li>
            <li>
              <b>Système d’alimentation :</b>
              <div>
                Carburateur, distributeur, pompe à injection, pompe électrique d’alimentation, turbocompresseur.
              </div>
            </li>
            <li>
              <b>Dispositif d’embrayage :</b>
              <div>
                Mécanisme et fourchette, cylindres émetteurs et récepteurs, leviers et biellettes de commande, butée et guide de butée.
              </div>
            </li>
            <li>
              <b>Système de refroidissement :</b>
              <div>
                Les différentes pompes, thermostat, ventilateur de circuit de refroidissement,
                refroidissement d’huile moteur et boîte de vitesses, radiateurs de refroidissement, échangeur air-air, compresseur
              </div>
            </li>
            <li>
              <b>Système de freinage :</b>
              <div>
                maîtres cylindres, servo-freins, cylindres de roues, pompes à vide,
                étriers de freins, limiteurs ou régulateurs de charge, flexibles,
                levier de frein à main, bloc hydraulique et capteurs.
              </div>
            </li>
            <li>
              <b>Equipement électrique :</b>
              <div>
                Démarreur, alternateur, régulateur, bobine, allumeur,
                système électronique d’injection, moteur d’essuie-glace de série uniquement,
                lève-glaces électriques et moteur de lève-glace de série uniquement,
                fermeture centralisée des portes, climatisation si d’origine,
                moteur de ventilation, pompe de lave-glace, moteur et mécanisme de toit ouvrant, interrupteurs, moteur des rétroviseurs.
              </div>
            </li>
            <li>
              <b>Dispositif de direction :</b>
              <div>
                Mécanique ou assistée, y compris tous les organes internes, pompe hydraulique,
                boîtier de renvoi ouintermédiaire, canalisation, réservoir, durites
                de direction assistée, colonne de direction et supports, axes et cardans, biellettes et rotules.
              </div>
            </li>
            <li>
              <b>Dispositif de suspension :</b>
              <div>
                Ressorts, axes de pivots et bagues, barres stabilisatrice, articulations,
                ras de suspension, ressorts, rotules et suspensions hydrauliques,
                roulements de moyeux, électrovanne, sphères de suspension avant, arrière et centrale.
              </div>
            </li>
            <li>
              <b>Sont de plus garantis dans la cellule :</b>
              <div>
                Pompe à eau, réservoirs eaux propres et usées, chauffe-eau, robinets,
                clapet de fermeture des sanitaires, bac à douche, agrégat réfrigérateur,
                transformateur et chargeur électrique, appareils de chauffage et de cuisson fixes,
                fermetures intérieures et fixation du mobilier, réfrigérateur, pulseurd’air,
                circuit gaz, organes électriques à l’exception des faisceaux.
              </div>
            </li>
            <li>
              <b>Option A :</b>
              <div>
                Cardans, mécanisme d’embrayage, maître-cylindre et assistance de freinage.
              </div>
            </li>
            <li>
              <b>Option B : </b>
              <div>
                Pompe à eau, radiateur, moto ventilateur, alternateur, démarreur.
              </div>
            </li>
            <li>
              <b>Option C : </b>
              <div>
                Turbo, pompe à injection.
              </div>
            </li>
        </template>

      <!--CAMPING CAR NOT NEW-->
        <template v-else>
            <li>
              <b>Moteur :</b>
              <div>
                Arbre à cames, coussinets de bielles ou de paliers, culbuteurs et tiges de culbuteurs,
                pignons et chaîne de distribution, pistons et axes de pistons, pompe à huile,
                segments, soupapes et guides de soupapes, vilebrequin, ainsi que la culasse et son joint.
              </div>
            </li>
            <li>
              <b>Boîte de vitesses : </b>
              <div>
                Manuelle ou automatique, tous les pignons d’engrenage, pignons de synchronisation, paliers,
                roulements à billes ou à aiguilles, à l’exclusion des commandes extérieures, de l’Overdrive et du dispositif d’embrayage.
              </div>
            </li>
            <li>
              <b>Dispositif de transmission :</b>
              <div>
                L’arbre de transmission longitudinal, différentiels, pignons et couronnes, y compris
                le pont arrière à l’exclusion des arbres de roues et des limiteurs de couple à friction.
              </div>
            </li>
            <li>
              <b>Sont de plus garantis dans la cellule :</b>
              <div>
                Pompe à eau, réservoirs eaux propres et usées, chauffe-eau, robinets,
                clapet de fermeture des sanitaires, bac à douche, agrégat réfrigérateur,
                transformateur et chargeur électrique, appareils de chauffage et de cuisson fixes,
                fermetures intérieures et fixation du mobilier, réfrigérateur, pulseurd’air,
                circuit gaz, organes électriques à l’exception des faisceaux.
              </div>
            </li>
            <li v-if="isOptionAExists(guaranty.details)">
              <b>Option A :</b>
              <div>
                Cardans, mécanisme d’embrayage, maître-cylindre et assistance de freinage.
              </div>
            </li>
            <li v-if="isOptionBExists(guaranty.details)">
              <b>Option B : </b>
              <div>
                Pompe à eau, radiateur, moto ventilateur, alternateur, démarreur.
              </div>
            </li>
            <li v-if="isOptionCExists(guaranty.details)">
              <b>Option C : </b>
              <div>
                Turbo, pompe à injection.
              </div>
            </li>
        </template>
    </ul>
</template>

<script>
    export default {
        name: 'DealerGuaranteesCampingCar',
        props: {
            guaranty: Object,
        },
        data() {
            return {
              isOui: "Oui",
              isNon: "Non",
            }
        },
        computed: {},
        methods: {
          isNewCampingCar(quoteDetails) {
            if (typeof quoteDetails !== 'undefined') {
              let isNew = (quoteDetails.is_new === this.isOui);
              return isNew;
            }
            return false;
          },
          isOptionAExists (quoteDetails) {
            return (quoteDetails && (quoteDetails.cardans === this.isOui));
          },
          isOptionBExists (quoteDetails) {
            return (quoteDetails && (quoteDetails.pumps === this.isOui));
          },
          isOptionCExists (quoteDetails) {
            return (quoteDetails && (quoteDetails.injections === this.isOui));
          },
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Garantie/DealerInsuranceCampingCar/DealerGuaranteesCampingCar.vue